/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface EntraExternalDExchangeBridgeTokenCodeGet$Params {
  code: string;
  ip?: string;
  deviceId?: string;
}

export function entraExternalDExchangeBridgeTokenCodeGet(http: HttpClient, rootUrl: string, params: EntraExternalDExchangeBridgeTokenCodeGet$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, entraExternalDExchangeBridgeTokenCodeGet.PATH, 'get');
  if (params) {
    rb.path('code', params.code, {});
    rb.query('ip', params.ip, {});
    rb.query('deviceId', params.deviceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthenticationStrictHttpResponse<string>;
    })
  );
}

entraExternalDExchangeBridgeTokenCodeGet.PATH = '/EntraExternalD/ExchangeBridgeToken/{code}';
